var $grid = $("#highlights-grid");

if (!$grid.length) return;

// Center-align the grid container when Masonry is enabled (lg and up).
function isLgAndUp() {
  return window.innerWidth >= 1024;
}

function setMasonryAlignment(centered) {
  if (centered) {
    $grid.css({
      'margin-left': 'auto',
      'margin-right': 'auto',
      'display': 'block',
      'float': 'none'
    });
  } else {
    $grid.css({
      'margin-left': '',
      'margin-right': '',
      'display': '',
      'float': ''
    });
  }
}

function initOrDestroyMasonry() {
  if (isLgAndUp()) {
    setMasonryAlignment(true);
    if (!$grid.data('masonry')) {
      $grid.masonry({
        itemSelector: ".highlight-item",
        columnWidth: ".grid-sizer",
        percentPosition: true,
        gutter: 16,
      });
    }
  } else {
    setMasonryAlignment(false);
    if ($grid.data('masonry')) {
      $grid.masonry('destroy');
    }
  }
}

// Initialize on load and resize
$(window).on('load resize', function () {
  initOrDestroyMasonry();
});
